import type { Action } from 'modules/global/generic.types';
import type { PaginatedTireQuote, PaginatedTireQuoteResponse, TireQuoteDataByIdState } from 'modules/tireQuote/types';
import { createReducer } from 'utils/ReduxUtils';

import * as actionTypes from '../../actionTypes';

const initialState: TireQuoteDataByIdState = {};

const updateOne = (state: TireQuoteDataByIdState, tireQuote: PaginatedTireQuote) => ({
  ...state,
  [tireQuote.id]: {
    ...(state?.[tireQuote.id] ?? {}),
    ...tireQuote,
  },
});

const updateAll = (state: TireQuoteDataByIdState, { payload }: Action<PaginatedTireQuoteResponse>) =>
  payload!.content?.reduce((newState, tireQuote) => updateOne(newState, tireQuote), state) ?? state;

export default createReducer(initialState, {
  [actionTypes.SEARCH_TIRE_QUOTES_SUCCESS]: updateAll,
});
